// SCREEN_CREATE (ページ作成) で使うAPI

// POST /vtuber-drafts
// 本人が作成したページを下書きとして保存する。この時点では公開しない(report_status: draft)
// draft: { channelId, name, description, iconUrl, youtubeUrl, attributes: string[] }
// 戻り値: { id, pageUrl, reportStatus }
export const createVtuberDraft = async (draft) => {
  const userId = localStorage.getItem("user");

  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/create`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, ...draft }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "下書きの保存に失敗しました");
  }

  return await response.json();
};
